import { render, staticRenderFns } from "./EventLocationForm.vue?vue&type=template&id=4b7716c8&"
import script from "./EventLocationForm.vue?vue&type=script&lang=js&"
export * from "./EventLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports